// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import {ProfilePopoverController} from './profile_popover_controller';

export default ProfilePopoverController;
